import { BrowserRouter, Navigate, Route, Routes, useParams, useSearchParams } from "react-router-dom";
import AppLayout from "./components/AppLayout";
import { AuthProvider, useAuth } from "./hooks/useAuth";
import ActivitiesPage from "./pages/ActivitiesPage";
import ActivityDetailPage from "./pages/ActivityDetailPage";
import AuthCallbackPage from "./pages/AuthCallbackPage";
import CheckEmailPage from "./pages/CheckEmailPage";
import GearPage from "./pages/GearPage";
import LoginPage from "./pages/LoginPage";
import PhotosPage from "./pages/PhotosPage";
import RegisterPage from "./pages/RegisterPage";
import SettingsPage from "./pages/SettingsPage";
import TrainingPage from "./pages/TrainingPage";
import TrainingPlanDetailPage from "./pages/TrainingPlanDetailPage";
import WellnessPage from "./pages/WellnessPage";

function IndexRoute() {
  const { signedIn } = useAuth();
  return <Navigate to={signedIn ? "/activities" : "/login"} replace />;
}

function LegacyMagicLinkRedirect() {
  const { token: pathToken } = useParams();
  const [params] = useSearchParams();
  const token = pathToken || params.get("token") || "";
  const target = new URLSearchParams(params);
  target.set("token", token);
  return <Navigate to={`/auth/callback?${target.toString()}`} replace />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route path="/auth/magic/:token" element={<LegacyMagicLinkRedirect />} />
          <Route path="/auth/magic" element={<LegacyMagicLinkRedirect />} />
          <Route element={<AppLayout />}>
            <Route index element={<IndexRoute />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/auth/check-email" element={<CheckEmailPage />} />
            <Route path="/activities" element={<ActivitiesPage />} />
            <Route path="/activities/:id" element={<ActivityDetailPage />} />
            <Route path="/wellness" element={<WellnessPage />} />
            <Route path="/photos" element={<PhotosPage />} />
            <Route path="/training" element={<TrainingPage />} />
            <Route path="/training/plans/:id" element={<TrainingPlanDetailPage />} />
            <Route path="/gear" element={<GearPage />} />
            <Route path="/settings" element={<SettingsPage />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
